import { CoreQuery } from '@/common/services/core-query';
import { EntitiesList } from '@/common/models/entities.enum';
import httpClient from '@/api/http-client';
import { Topic } from '@/admin/topics/models/topic';

export const putTopic = (topic: Topic) => {
    const q = new CoreQuery();

    q.path([EntitiesList.TOPICS, EntitiesList.PERSONA, EntitiesList.TOPIC]);
    return httpClient
        .put<Topic>(q.query, topic, q.axiosConfigParams)
        .then(({ data }) => data)
        .catch(e => {
            throw e.response.data;
        });
};
